// Campus photo for /colleges/louisiana-state-university: CC BY 3.0, by davidpinter, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMemorial_Tower_and_Thomas_D._Boyd_Hall%2C_Louisiana_State_University%2C_Baton_Rouge%2C_Louisana.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/louisiana-state-university/; credited under the photo.
const photo = {
    "slug": "louisiana-state-university",
    "alt": "Memorial Tower and Thomas D. Boyd Hall on the campus of Louisiana State University in Baton Rouge",
    "src": "/colleges/louisiana-state-university/campus-1600.webp",
    "srcSmall": "/colleges/louisiana-state-university/campus-800.webp",
    "srcMid": "/colleges/louisiana-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/louisiana-state-university/og.jpg",
    "title": "Memorial Tower and Thomas D. Boyd Hall, Louisiana State University, Baton Rouge, Louisana",
    "author": "davidpinter",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMemorial_Tower_and_Thomas_D._Boyd_Hall%2C_Louisiana_State_University%2C_Baton_Rouge%2C_Louisana.jpg",
    "read": "2026-10-02"
};

export default photo;
